import { memo } from "react";
import ContentsFileValue from "../ContentsFileValue/ContentsFileValue";
import Captions from "./Captions";
import { INewFileProps } from "./models";

const ContentFile: React.FC<INewFileProps> = ({
  index,
  onFileSelected,
  allLanguages,
  contentMediaFiles,
  mediaTypeCode,
}) => {
  return (
    <>
      <ContentsFileValue
        onFileSelected={onFileSelected}
        index={index}
        mediaTypeCode={mediaTypeCode}
      />
      <Captions
        index={index}
        allLanguages={allLanguages}
        contentMediaFiles={contentMediaFiles}
      />
    </>
  );
};

export default memo(ContentFile);
